import { useCallback } from 'react'
import { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import { TripItem } from 'tripPlanner/types/tripItem'
import { usePatchTripItem } from 'tripPlanner/hooks/api/tripItem'
import * as Analytics from 'analytics/analytics'
import { offerIdOrPlaceId } from 'tripPlanner/utils/analytics'

export default function useAddSuggestedItem(item: TripItem) {
  const { mutate: patchItem } = usePatchTripItem()

  return useCallback(() => {
    patchItem({
      tripId: item.tripId,
      tripItemId: item.id,
      tripItem: {
        type: item.type,
        isSuggested: false,
      },
    })

    const analyticsId = offerIdOrPlaceId(item)

    if (analyticsId) {
      Analytics.trackClientEvent({
        subject: `add_recommended_item_${analyticsId}`,
        action: 'concierge',
        type: 'interaction',
        category: AnalyticsPage.tripPlanner,
      })
    }
  }, [item, patchItem])
}
